import React from "react";
import { View, Text } from "react-native";

export default function ({text, style, colorScheme, color}) {
  const textColor = color || (colorScheme === "dark" ? "white" : "black");
  const shadowColor = color === "white" || colorScheme === "dark" ? "black" : "white";

  return (
    <View style={{ backgroundColor: "transparent" }}>
      <View style={{ backgroundColor: "transparent" }}>
        <Text
          style={[
            style,
            {
              color: textColor,
              textShadowColor: shadowColor,
              textShadowOffset: { width: -1, height: -1 },
              textShadowRadius: 1,
            },
          ]}
        >
          {text}
        </Text>
      </View>
      <View style={{ position: "absolute", backgroundColor: "transparent" }}>
        <Text
          style={[
            style,
            {
              color: textColor,
              textShadowColor: shadowColor,
              textShadowOffset: { width: 1, height: 1 },
              textShadowRadius: 1,
            },
          ]}
        >
          {text}
        </Text>
      </View>
      <View style={{ position: "absolute", backgroundColor: "transparent" }}>
        <Text
          style={[
            style,
            {
              color: textColor,
              textShadowColor: shadowColor,
              textShadowOffset: { width: -1, height: 1 },
              textShadowRadius: 1,
            },
          ]}
        >
          {text}
        </Text>
      </View>
      <View style={{ position: "absolute", backgroundColor: "transparent" }}>
        <Text
          style={[
            style,
            {
              color: textColor,
              textShadowColor: shadowColor,
              textShadowOffset: { width: 1, height: -1 },
              textShadowRadius: 1,
            },
          ]}
        >
          {text}
        </Text>
      </View>
    </View>
  );
}
